import { Icon } from 'leaflet';

const LeafIcon = Icon.extend({
  options: {
    iconUrl: '/images/map-pin.svg',
    iconSize: [26, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -24],
  },
});

export const pin = new LeafIcon();
